import request from '@/utils/request'
// 历史记录接口
export function getPatientHostory(patientId,pageNum,pageSize) {
  return request({
    url: `/feature/questionnaire/getPatientHostory?patientId=${patientId}&pageNum=${pageNum}&pageSize=${pageSize}`,
    method: 'get',
  })
}